import React, { useState } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import toast from 'react-hot-toast';

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { resetPassword } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (newPassword !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    if (newPassword.length < 8) {
      setError('Password must be at least 8 characters');
      return;
    }

    if (!token) {
      setError('Invalid reset token');
      return;
    }

    setLoading(true);

    const result = await resetPassword(token, newPassword);

    if (result.success) {
      toast.success('Password reset successfully! You can now log in with your new password.');
      navigate('/login');
    } else {
      setError(result.error || 'Failed to reset password. Please try again.');
    }

    setLoading(false);
  };

  if (!token) {
    return (
      <div style={{
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", sans-serif',
        background: 'linear-gradient(135deg, #00684A 0%, #00ED64 100%)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        padding: '20px',
      }}>
        <div style={{
          background: 'white',
          borderRadius: '12px',
          boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
          padding: '40px',
          width: '100%',
          maxWidth: '400px',
          textAlign: 'center',
        }}>
          <h1 style={{ color: '#DB3030', marginBottom: '20px' }}>Invalid Reset Link</h1>
          <p style={{ marginBottom: '20px', color: '#5C6C75' }}>The password reset link is invalid or has expired.</p>
          <Link
            to="/login"
            style={{
              color: '#00684A',
              textDecoration: 'none',
              fontSize: '14px',
            }}
          >
            Back to Login
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div style={{
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", sans-serif',
      background: 'linear-gradient(135deg, #00684A 0%, #00ED64 100%)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      padding: '20px',
    }}>
      <div style={{
        background: 'white',
        borderRadius: '12px',
        boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
        padding: '40px',
        width: '100%',
        maxWidth: '400px',
      }}>
        <div style={{ textAlign: 'center', marginBottom: '30px' }}>
          <h1 style={{
            color: '#00684A',
            fontSize: '24px',
            marginBottom: '10px',
          }}>
            Reset Password
          </h1>
          <p style={{
            color: '#5C6C75',
            fontSize: '14px',
          }}>
            Enter your new password
          </p>
        </div>

        {error && (
          <div style={{
            background: '#FFEAE5',
            border: '1px solid #FFCDC7',
            color: '#970606',
            padding: '12px',
            borderRadius: '8px',
            marginBottom: '20px',
            fontSize: '14px',
          }}>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '20px' }}>
            <label style={{
              display: 'block',
              color: '#3D4F58',
              fontWeight: '500',
              marginBottom: '8px',
              fontSize: '14px',
            }}>
              New Password
            </label>
            <input
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
              autoComplete="new-password"
              style={{
                width: '100%',
                padding: '12px 15px',
                border: '2px solid #E8EDEB',
                borderRadius: '8px',
                fontSize: '14px',
                transition: 'border-color 0.3s',
                outline: 'none',
              }}
              onFocus={(e) => e.target.style.borderColor = '#00684A'}
              onBlur={(e) => e.target.style.borderColor = '#E8EDEB'}
            />
          </div>

          <div style={{ marginBottom: '20px' }}>
            <label style={{
              display: 'block',
              color: '#3D4F58',
              fontWeight: '500',
              marginBottom: '8px',
              fontSize: '14px',
            }}>
              Confirm Password
            </label>
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              autoComplete="new-password"
              style={{
                width: '100%',
                padding: '12px 15px',
                border: '2px solid #E8EDEB',
                borderRadius: '8px',
                fontSize: '14px',
                transition: 'border-color 0.3s',
                outline: 'none',
              }}
              onFocus={(e) => e.target.style.borderColor = '#00684A'}
              onBlur={(e) => e.target.style.borderColor = '#E8EDEB'}
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            style={{
              width: '100%',
              padding: '12px',
              background: 'linear-gradient(135deg, #00684A 0%, #00ED64 100%)',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              fontSize: '16px',
              fontWeight: '600',
              cursor: loading ? 'not-allowed' : 'pointer',
              transition: 'transform 0.2s, box-shadow 0.2s',
              opacity: loading ? 0.6 : 1,
            }}
            onMouseEnter={(e) => {
              if (!loading) {
                e.target.style.transform = 'translateY(-2px)';
                e.target.style.boxShadow = '0 5px 15px rgba(0, 104, 74, 0.4)';
              }
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = 'none';
            }}
          >
            {loading ? 'Resetting...' : 'Reset Password'}
          </button>
        </form>

        <div style={{
          textAlign: 'center',
          marginTop: '20px',
        }}>
          <Link
            to="/login"
            style={{
              color: '#00684A',
              textDecoration: 'none',
              fontSize: '14px',
            }}
          >
            Back to Login
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;



